module.exports = __webpack_public_path__ + "static/media/structure.564e0287.png";